export function findMatches(combinedGroups, numberOfMatches, modelBlacklist) {
  const results = [];

  for (const group of combinedGroups) {
    for (const item of group) {
      if (!modelBlacklist.includes(item.modelName)) {
        results.push(item.modelName);

        if (results.length >= numberOfMatches) {
          return results;
        }
      }
    }
  }

  return results;
}
